import moment from 'moment';
import 'moment-timezone';
import { roundNumber } from '@utils';

moment.tz.setDefault('Europe/Kiev');

const dateFormater = (data) => {
  if (!data) {
    return '';
  }
  const date = new Date(data);
  return date.toLocaleDateString('uk', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
};
const formatProducts = (arrayProducts, datesInventory) => {
  const [start, end] = datesInventory ? datesInventory : [null, null];
  const newArrayProducts = [];
  arrayProducts.map(
    ({ products = [], company_name, storage, document_no, capacity: capacityAll, supplier, carrier }) => {
      products?.map(({ barcode, grade, length, product, capacity, date_inventory, date_inventory_history }) => {
        const dateInventory = dateFormater(date_inventory);
        const dateInventoryHistory = date_inventory_history?.map((item) => dateFormater(item)).join(', ');
        const nowData = date_inventory ? moment(new Date(date_inventory)).startOf('day') : null;
        let capacityInventory = capacity ? +capacity : 0;

        if (start && end && !date_inventory) {
          return null;
        }
        if (
          date_inventory &&
          start &&
          end &&
          (nowData.isBefore(moment(new Date(start)).startOf('day')) ||
            nowData.isAfter(moment(new Date(end)).startOf('day')))
        ) {
          return null;
        }
        if (!capacityInventory) {
          capacityInventory = capacityAll / products?.length;
        }

        newArrayProducts.push({
          barcode,
          grade: grade.title,
          length,
          product: product.title,
          company_name,
          storage: storage.title,
          document_no,
          supplier: supplier.title,
          capacity: capacityInventory ? roundNumber(capacityInventory) : 0,
          carrier: carrier.title,
          date_inventory: dateInventory,
          date_inventory_history: dateInventoryHistory,
        });
      });
    }
  );

  return newArrayProducts;
};

export default formatProducts;
